var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"jpasta-loading",rawName:"v-jpasta-loading",value:(true),expression:"true"}],staticClass:"mainWrapper",staticStyle:{"width":"100%","height":"100%"},style:({
    'min-height': _vm.mainWrapperHeight + 'px',
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }